/**
 * Pre-compiled es messages for LoadingSpinner
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { default: `Cargando datos` };
